import type { ITheme } from '@ben/orion/utils/theme';
import { useMemo } from 'react';
import { useTheme } from 'styled-components';

const DOCUSEAL_HOST = 'docuseal.eu';

const buildCustomCss = ({ palette }: ITheme): string => `
  .template-title {
    display: none;
  }

  .highlight,
  .field-highlight,
  .field--highlighted,
  [class*='highlight'] {
    background-color: ${palette.primary.bg} !important;
  }

  .field-area-active,
  .field-area-highlight,
  .field-area,
  [class*='field-area']:not([class*='label']),
  [class*='field-value'],
  [class*='field-input'],
  [class*='field-area-active']:not([class*='label']),
  [class*='field-area'][class*='active']:not([class*='label']),
  [class*='field-area'][style*='background: #f3f3f3'],
  [class*='field-area'][style*='background-color: #f3f3f3'],
  [class*='field-area'][style*='background-color: rgb(243, 243, 243)'] {
    background-color: ${palette.primary.bg} !important;
  }

  [class*='border-red-'],
  [class*='border-red'],
  [style*='border-color: rgb(248, 113, 113)'],
  [style*='border-color: #f87171'],
  [style*='outline-color: rgb(248, 113, 113)'],
  [style*='outline-color: #f87171'] {
    border-color: transparent !important;
    outline-color: ${palette.primary.main} !important;
  }

  .draw-canvas {
    background-color: ${palette.primary.bg};
  }

  .submit-form-button,
  .expand-form-button {
    background-color: ${palette.primary.main};
    border: 0;
    border-radius: 8px;
    color: ${palette.neutral['00']};
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.25rem;
    letter-spacing: 0.01em;
  }

  .submit-form-button:hover,
  .expand-form-button:hover {
    background-color: ${palette.primary.dark};
  }

  .submit-form-button:disabled,
  .expand-form-button:disabled {
    background-color: ${palette.primary.light};
    color: ${palette.neutral['00']};
    cursor: not-allowed;
  }
`;

export const useDocusealEmbedConfig = () => {
  const theme = useTheme();

  return useMemo(
    () => ({
      host: DOCUSEAL_HOST,
      expand: false,
      backgroundColor: theme.palette.primary.bg,
      customCss: buildCustomCss(theme),
      withDownloadButton: false,
      withSendCopyButton: false,
    }),
    [theme]
  );
};
